import Route from 'cio/routes/base';

export default class ConfirmAccountRedirectRoute extends Route {
  beforeModel(transition) {
    let { confirmation_code: confirmationCode } = transition.to.queryParams;
    return this.router.replaceWith('confirm_account', { queryParams: { confirmationCode } });
  }
}
